import React from "react";
import Header from "./components/Header";
import ChatContainer from "./components/ChatContainer";
import MessageInput from "./components/MessageInput";
import { userAvatar } from "./data/messages";
import { useChat } from "./hooks/useChat";

function App() {
  const { messages, isTyping, sendUserMessage } = useChat();

  return (
    <div className="app">
      <Header />
      <ChatContainer
        messages={messages}
        isTyping={isTyping}
        userAvatar={userAvatar}
      />
      <MessageInput onSendMessage={sendUserMessage} />
    </div>
  );
}

export default App;
 